// src/services/ProductsService.js
import Axhelper from '@/lib/Axhelper'

class ProductsService {
	constructor() {
		this.baseUrl = window.RUNTIME_CONFIG.API_URL
		this.endpoints = {
			all: `/api/products/all`,
			details: `/api/products/details`,
			add: `/api/products/`,
			update: `/api/products/`,
			remove: `/api/products/`
		}
	}

	/**
	 * Fetch all products (GET /products/all)
	 * @returns {Promise<{data: Array, error: string|null}>}
	 */
	async getAllProducts() {
		try {
			const res = await Axhelper.sendGetAsync(this.endpoints.all)
			if (res?.error) {
				return { data: [], error: res.error }
			}
			return { data: Array.isArray(res?.data) ? res.data : [], error: null }
		} catch (e) {
			console.error('ProductsService.getAllProducts error:', e)
			return { data: [], error: e?.message || 'Failed to fetch products' }
		}
	}

	/**
	 * Fetch single product by id (GET /products/details/:id)
	 * Kept for convenience; safe to remove if unused.
	 */
	async getProductById(productId) {
		try {
			if (!productId) return { data: null, error: 'Invalid product ID' }
			const url = `${this.endpoints.details}/${encodeURIComponent(productId)}`
			const res = await Axhelper.sendGetAsync(url)
			if (res?.error) return { data: null, error: res.error }
			return { data: res?.data ?? null, error: null }
		} catch (e) {
			console.error('ProductsService.getProductById error:', e)
			return { data: null, error: e?.message || 'Failed to fetch product' }
		}
	}

	async addProduct(productData) {
		try {
			const res = await Axhelper.sendPostAsync(this.endpoints.add, productData)
			if (res?.error) {
				return { data: null, error: res.error }
			}
			return { data: res?.data ?? null, error: null }
		} catch (e) {
			console.error('ProductsService.addProduct error:', e)
			return { data: null, error: e?.message || 'Failed to add product' }
		}
	}

	async updateProduct(productId, productData) {
		try {
			if (!productId) {
				return { data: null, error: 'Invalid product ID' }
			}
			const url = `${this.endpoints.update}${encodeURIComponent(productId)}`
			const res = await Axhelper.sendPutAsync(url, productData)
			if (res?.error) {
				return { data: null, error: res.error }
			}
			return { data: res?.data ?? null, error: null }
		} catch (e) {
			console.error('ProductsService.updateProduct error:', e)
			return { data: null, error: e?.message || 'Failed to update product' }
		}
	}

	async deleteProduct(productId) {
		try {
			if (!productId) {
				return { data: null, error: 'Invalid product ID' }
			}
			const url = `${this.endpoints.remove}${encodeURIComponent(productId)}`
			const res = await Axhelper.sendDeleteAsync(url)
			if (res?.error) {
				return { data: null, error: res.error }
			}
			return { data: res?.data ?? null, error: null }
		} catch (e) {
			console.error('ProductsService.deleteProduct error:', e)
			return { data: null, error: e?.message || 'Failed to delete product' }
		}
	}
	
}

export default new ProductsService()
